import React, { useEffect, useRef, useState } from "react";
import ClientLayoutWithOutHeader from "../components/layout/ClientLayoutWithOutHeaderForTeenPatti";
import TpStudioHeader from "./tp-studio-header";
import TPStudioSidebar from "./TPStudioSidebar";
import TpStudioLoader from "../../client/tp-studio/tp-studio-loader";

import "../../../assets/topstudio/styles/CardsSprite.css";
import GameTimer from "./components/GameTimer";
import spriteUrl from "../../../assets/topstudio/styles/svg/sprite.css-d6f47756.svg";
import "../../../assets/topstudio/styles/Player.css";
import "../../../assets/topstudio/styles/AAA.css";
import useSocket from "../../../hooks/useSocket";
import useClosedPhaseOverlay from "../../../hooks/useClosedPhaseOverlay";
import BetfairCasinoBetslipWeb from "../betfair-games/betfair_casino_betslip_web";
import axiosInstance from "../../../utils/axiosInstance";
import TPPopUpBetSlip from "./teenpatti_casino_betslip_popup.jsx";
import { isMobile } from "react-device-detect";
import Card32Result from "../../client/tp-studio/tp-result/Card32Result.jsx";
import Card32Rules from "./pop-up/32card-rules.jsx";
import TeenPattisCasinoBetslipWeb from "./teenpatti_casino_betslip_web";
import Volume from "./Volume";

import { useDispatch, useSelector } from "react-redux";
import { setUserData } from "../../../store/userSlice";

export default function Card32Virtual() {
  const dispatch = useDispatch();

  const [stakeLimit, setStakeLimit] = useState(0);

  const [showRules, setShowRules] = useState(false);
  const [open, setOpen] = useState(false);
  const [displayLoader, setDisplayLoader] = useState(true);
  const [gameRoundId, setGameRoundId] = useState("");
  const [showBetSlip, setShowBetSlip] = useState(false);
  const [placeBetObject, setPlaceBetObject] = useState({});
  const [betErrorMessageObj, setBetErrorMessage] = useState({});
  const [activeTabIndex, setActiveTabIndex] = useState(1);

  const [book1, setBook1] = useState("");
  const [book2, setBook2] = useState("");
  const [book3, setBook3] = useState("");
  const [book4, setBook4] = useState("");
  const [betList, setBetList] = useState([]);
  const [totalBets, setTotalBets] = useState(0);
  const [showResult, setShowResult] = useState(false);
  const [lastStatus, setLastStatus] = useState(null);
  const [resultData, setResultData] = useState([]);

  const [resultList, setResultList] = useState([]);

  const sessionUser = useSelector((s) => s.userStore.data);
  const updateUserData = async (userData) => {
    if (!userData || !sessionUser) return;
    await dispatch(
      setUserData({
        ...sessionUser,
        fname: userData.fname ?? sessionUser.fname,
        uname: userData.uname ?? sessionUser.uname,
        bz_balance: userData.bz_balance ?? sessionUser.bz_balance,
        opin_bal: userData.opin_bal ?? sessionUser.opin_bal,
        user_role: sessionUser.user_role,
        _id: sessionUser._id
      })
    );
  };

  ///
  const { data, isConnected } = useSocket({
    marketId: null,
    mtype: "virtual",
    type: "32Cards_virtual"
  });
  //console.log("Socket data:", data);

  const [b1, setB1] = useState(0);
  const [b2, setB2] = useState(0);
  const [b3, setB3] = useState(0);
  const [b4, setB4] = useState(0);

  const [l1, setL1] = useState(0);
  const [l2, setL2] = useState(0);
  const [l3, setL3] = useState(0);
  const [l4, setL4] = useState(0);

  const [c1, setC1] = useState("");
  const [c2, setC2] = useState("");
  const [c3, setC3] = useState("");
  const [c4, setC4] = useState("");
  const [roundId, setRoundId] = useState("");
  const [eventStatus, setEventStatus] = useState("");
  const [timeLeftGame, setTimeLeftGame] = useState("");
  const [suspend1, setSuspend1] = useState("");

  const [cardNum1, setCardNum1] = useState(0);
  const [cardNum2, setCardNum2] = useState(0);
  const [cardNum3, setCardNum3] = useState(0);
  const [cardNum4, setCardNum4] = useState(0);

  const [c1Img, setC1Img] = useState("");
  const [c2Img, setC2Img] = useState("");
  const [c3Img, setC3Img] = useState("");
  const [c4Img, setC4Img] = useState("");
  const [cards_desc, setCards_desc] = useState("");

  const [player8Winner, setPlayer8Winner] = useState(false);
  const [player9Winner, setPlayer9Winner] = useState(false);
  const [player10Winner, setPlayer10Winner] = useState(false);
  const [player11Winner, setPlayer11Winner] = useState(false);

  const [visibleCards, setVisibleCards] = useState(0);
  const [cardsSettled, setCardsSettled] = useState(false);
  const cardRevealTimersRef = useRef([]);
  const cardsSettleTimerRef = useRef(null);
  const [showBetSlipPopup, setShowBetSlipPopup] = useState(false);
  const [profileData, setProfileData] = useState(null);
  const [betButtonShow, setBetButtonShow] = useState(true);
  const [betButtonShowLoaderShow, setButtonShowLoaderShow] = useState(false);
  let betfairOdds = null;

  let resultCardNo = 0;

  const payload = data?.data?.data;
  const { isSuspended, suspendedText } = useClosedPhaseOverlay(
    payload?.evt_status,
    payload?.cat_mid,
    setShowBetSlipPopup
  );
  //console.log("payload->", payload);

  useEffect(() => {
    if (!payload) return;
    updateUserData(data?.user);

    setDisplayLoader(false);

    if (lastStatus != payload.evt_status && payload.evt_status === "OPEN") {
      //setPlacedBets([]); //clearing placed bets on status change
      setPlayer8Winner(false);
      setPlayer9Winner(false);
      setPlayer10Winner(false);
      setPlayer11Winner(false);
      setCardsSettled(false);
      clearTimeout(cardsSettleTimerRef.current);
    }

    betfairOdds = payload;

    if (lastStatus != payload.evt_status) {
      setLastStatus(payload.evt_status);
    }

    //console.log(betfairOdds);

    setRoundId(betfairOdds?.cat_mid);
    setEventStatus(betfairOdds?.evt_status);
    setTimeLeftGame(betfairOdds.left_time);
    setSuspend1(betfairOdds.suspend1);
    setB1(betfairOdds?.b1);
    setB2(betfairOdds?.b2);
    setB3(betfairOdds?.b3);
    setB4(betfairOdds?.b4);

    setL1(betfairOdds?.l1);
    setL2(betfairOdds?.l2);
    setL3(betfairOdds?.l3);
    setL4(betfairOdds?.l4);

    setC1(betfairOdds.c1 == 1 ? 8 : betfairOdds.c1);
    setC2(betfairOdds.c2 == 1 ? 9 : betfairOdds.c2);
    setC3(betfairOdds.c3 == 1 ? 10 : betfairOdds.c3);
    setC4(betfairOdds.c4 == 1 ? 11 : betfairOdds.c4);

    if (betfairOdds.result !== "") {
      if (betfairOdds.result == 1) {
        setPlayer8Winner(true);
        setPlayer9Winner(false);
        setPlayer10Winner(false);
        setPlayer11Winner(false);
      } else if (betfairOdds.result == 2) {
        setPlayer8Winner(false);
        setPlayer9Winner(true);
        setPlayer10Winner(false);
        setPlayer11Winner(false);
      } else if (betfairOdds.result == 3) {
        setPlayer8Winner(false);
        setPlayer9Winner(false);
        setPlayer10Winner(true);
        setPlayer11Winner(false);
      } else if (betfairOdds.result == 4) {
        setPlayer8Winner(false);
        setPlayer9Winner(false);
        setPlayer10Winner(false);
        setPlayer11Winner(true);
      }
    }

    if (betfairOdds.cards_desc != "") {
      setCards_desc(betfairOdds?.cards_desc);
      let cardsDesc = betfairOdds.cards_desc.split(",") || [];
      setC1Img(cardsDesc[0]);
      setC2Img(cardsDesc[1]);
      setC3Img(cardsDesc[2]);
      setC4Img(cardsDesc[3]);

      setCardNum1(splitCards(c1Img));
      setCardNum2(splitCards(c2Img));
      setCardNum3(splitCards(c3Img));
      setCardNum4(splitCards(c4Img));
    } else {
      setCards_desc("");
      setC1Img("");
      setC2Img("");
      setC3Img("");
      setC4Img("");

      setCardNum1(0);
      setCardNum2(0);
      setCardNum3(0);
      setCardNum4(0);
    }
  }, [payload]);

  useEffect(() => {
    cardRevealTimersRef.current.forEach(clearTimeout);
    cardRevealTimersRef.current = [];
    setCardsSettled(false);
    clearTimeout(cardsSettleTimerRef.current);

    if (!cards_desc) {
      setVisibleCards(0);
      return;
    }

    setVisibleCards(1);
    cardRevealTimersRef.current = [
      setTimeout(() => setVisibleCards(2), 1000),
      setTimeout(() => setVisibleCards(3), 2000),
      setTimeout(() => setVisibleCards(4), 3000)
    ];

    return () => {
      cardRevealTimersRef.current.forEach(clearTimeout);
      clearTimeout(cardsSettleTimerRef.current);
    };
  }, [cards_desc]);

  const formatTruncate = (value) => {
    let num = Math.round(value);
    const truncated = Math.floor(num * 1000) / 1000;

    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 3
    }).format(truncated);
  };

  useEffect(() => {
    if (visibleCards < 4 || !cards_desc) {
      setCardsSettled(false);
      clearTimeout(cardsSettleTimerRef.current);
      return;
    }

    clearTimeout(cardsSettleTimerRef.current);
    cardsSettleTimerRef.current = setTimeout(() => {
      setCardsSettled(true);
    }, 1000);

    return () => clearTimeout(cardsSettleTimerRef.current);
  }, [visibleCards, cards_desc]);

  const activeTab = async (tab1) => {
    setActiveTabIndex(tab1);
    if (tab1 == 2) {
      showResultDetail();
    }
  };

  const showResultDetail = async () => {
    let resultObj = {};
    resultObj.game_type = "32Cards_virtual";

    //console.log("BEFORE API CALL");

    const response = await axiosInstance.post("/teenpatti-results", resultObj);
    //console.log("FULL RESPONSE", response.data);
    //console.log("AFTER API CALL");

    setResultData(response.data.results_list);
    //console.log("response->", resultData);
  };

  const payloadResult = data?.data?.result;
  //console.log("data:", payload);

  useEffect(() => {
    if (!payloadResult) return;

    if (payloadResult !== "") {
      //console.log("payloadResult->", payloadResult);
      setResultList([]);
      setResultList(payloadResult);
    }
  }, [payloadResult]);

  function splitCards(imgData) {
    let imgVal = imgData.split("");
    let resultCardVal = imgVal[0];

    if (resultCardVal == "J") {
      resultCardVal = 11;
    }
    if (resultCardVal == "Q") {
      resultCardVal = 12;
    }
    if (resultCardVal == "K") {
      resultCardVal = 13;
    }
    if (resultCardVal == "1") {
      resultCardVal = 10;
    }
    return (resultCardNo = parseInt(resultCardVal));
  }

  const closeBetSlipMobile = () => {
    setShowBetSlipPopup(false);
    setBetErrorMessage({});
  };
  const fetchProfile = async () => {
    try {
      const { data } = await axiosInstance.get("/profile");
      setProfileData(data);
    } catch (error) {
      console.log("Failed to load profile data:", error);
    }
  };

  const betStakeLimit = async () => {
    try {
      const { data } = await axiosInstance.get("/profile/bet-stake-limit");
      if(data!=null && data!==undefined)
      {
         let limit  =data?.myBetLimit?.teenpatiStudio;
         setStakeLimit(formatTruncate(limit));
      }
    } catch (error) {
      console.log("Failed to load profile data:", error);
    }
    }; 

  useEffect(() => {
    fetchProfile();
    betStakeLimit();
  }, []);

  /// place bet ///

  const showBetfairBetSlip = (bettype, teamname, price) => {
    let placeBetObject = {
      amount: 0,
      catmid: "",
      market_type: "m",
      game_name: "32card_virtual"
    };
    placeBetObject.catmid = roundId;
    //console.log(placeBetObject);
    placeBetObject.odds = price;
    placeBetObject.teamname = teamname;
    placeBetObject.bettype = bettype;
    placeBetObject.game_type = 7;

    setPlaceBetObject(placeBetObject);
    //console.log("isMobile: ", isMobile);
    if (isMobile) {
      setShowBetSlipPopup(true);
    } else {
      setShowBetSlip(true);
    }
    //showBetfairSlipStatus = true;
  };

  const closeBetSlip = () => {
    setShowBetSlip(false);
  };

  const placeBet = async (amount, profit) => {
    placeBetObject.amount = amount;
    placeBetObject.profit = 0;

    try {
      const response = await axiosInstance.post(
        "/32card-virtual",
        placeBetObject
      );
      //console.log(response);
      if (
        response.data !== undefined &&
        response.data !== null &&
        response.data.status !== undefined &&
        response.data.status !== null
      ) {
        let messageObj = {};
        if (response.data.status) {
          messageObj.status = true;
        } else {
          messageObj.status = false;
        }
        messageObj.message = response.data.message;
        setBetErrorMessage(messageObj);
        getBook();
        setShowBetSlipPopup(false);
      }
    } catch (error) {
      if (error.response.data !== undefined && error.response.data !== null) {
        if (
          error.response.data.status !== undefined &&
          error.response.data.status !== null &&
          error.response.data.status === false
        ) {
          let errorMessage = error.response.data.message;
          let messageObj = {};
          messageObj.status = false;
          messageObj.message = errorMessage;
          setBetErrorMessage(messageObj);
        }
      }
    }
  };

  const getBook = async () => {
    let bookObject = {};
    bookObject.roundId = roundId; // roundId;
    bookObject.game_type = "32card-virtual";
    //console.log(roundId);
    const response = await axiosInstance.post("/tp20-book", bookObject);
    //console.log("response->", response.data);
    ///
    let userbook = response.data.userbook;
    let bet_list = response.data.bets_list;
    if (userbook.length > 0) {
      let book1Val = userbook[0].rnr1s;
      let book2Val = userbook[0].rnr2s;
      let book3Val = userbook[0].rnr3s;
      let book4Val = userbook[0].rnr4s;

      setBook1(book1Val);
      setBook2(book2Val);
      setBook3(book3Val);
      setBook4(book4Val);
    } else {
      setBook1("");
      setBook2("");
      setBook3("");
      setBook4("");
    }

    if (bet_list.length > 0) {
      setTotalBets(bet_list.length);
      setBetList(bet_list);
    } else {
      setBetList([]);
    }

    ///
    return response;
  };

  useEffect(
    (roundId) => {
      getBook();
    },
    [roundId]
  ); // Empty dependency array
  /// place bet ///

  ///
  const SUITS = ["S", "H", "D", "C"]; // Spades, Hearts, Diamonds, Clubs
  const RANKS = [
    "A",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "10",
    "J",
    "Q",
    "K"
  ];
  const SUIT_BASE = { S: 0, H: 13, D: 26, C: 39 };

  function spriteIndexForCard({ suit, rank }) {
    const base = SUIT_BASE[suit];
    const rankIdx = RANKS.indexOf(rank);
    return base + rankIdx;
  }

  function classForCard(card) {
    const idx = spriteIndexForCard(card);
    return `open_cardTP sprite-card-chs-card svg-card_simple_${idx}-dims d-card RSMImageView2 svg-card_simple_${idx}`;
  }

  /** ---- Deck + helpers ---- **/
  function buildDeck() {
    const deck = [];
    for (const s of SUITS)
      for (const r of RANKS) deck.push({ suit: s, rank: r });
    return deck;
  }

  function shuffle(array) {
    const a = array.slice();
    for (let i = a.length - 1; i > 0; i--) {
      const j = (Math.random() * (i + 1)) | 0;
      [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
  }

  /** ---- State ---- **/
  const DEAL_MS = 1000; // one card every 3s
  const [shoe, setShoe] = useState(() => shuffle(buildDeck()));
  const [playerA, setPlayerA] = useState([]); // Player A hand
  const [playerB, setPlayerB] = useState([]); // Player B hand
  const [step, setStep] = useState(0); // 0..6 (6 deals total)

  // timer display state (for base-timer circle)
  const [timeLeft, setTimeLeft] = useState(DEAL_MS); // ms left in the current 3s window
  const [tickId, setTickId] = useState(0); // increases each time a card is dealt (used to reset countdown)

  // refs for intervals/timeouts to clean up
  const dealIntervalRef = useRef(null);
  const countdownIntervalRef = useRef(null);
  const restartTimeoutRef = useRef(null);

  /** Start a fresh round and begin auto-dealing */
  function startRound() {
    // cleanup any prior timers
    clearInterval(dealIntervalRef.current);
    clearInterval(countdownIntervalRef.current);
    clearTimeout(restartTimeoutRef.current);

    setShoe((prev) => (prev.length < 10 ? shuffle(buildDeck()) : prev));
    setPlayerA([]);
    setPlayerB([]);
    setStep(0);
    setTimeLeft(DEAL_MS);
    setTickId((id) => id + 1);

    // 1) Deal a card every 3 seconds
    dealIntervalRef.current = setInterval(() => {
      setStep((prev) => prev + 1); // triggers the deal effect below
      setTickId((id) => id + 1); // resets countdown
      setTimeLeft(DEAL_MS);
    }, DEAL_MS);

    // 2) Countdown UI: update the circular timer ~10x/sec
    countdownIntervalRef.current = setInterval(() => {
      setTimeLeft((prev) => (prev <= 100 ? DEAL_MS : prev - 100));
    }, 100);
  }

  /** Perform deal on each step: 1→A, 2→B, 3→A, 4→B, 5→A, 6→B; auto-restart after 6 */
  useEffect(() => {
    if (step === 0) return;

    setShoe((prevShoe) => {
      if (prevShoe.length === 0) return prevShoe;

      const [top, ...rest] = prevShoe;

      // 👇 change is here: give first 3 cards to A, next 3 to B
      const dealToA = step <= 3;

      if (dealToA) setPlayerA((h) => [...h, top]);
      else setPlayerB((h) => [...h, top]);

      // after sixth deal, stop intervals and schedule a fresh round
      if (step === 6) {
        clearInterval(dealIntervalRef.current);
        clearInterval(countdownIntervalRef.current);
        setTimeLeft(0);
        restartTimeoutRef.current = setTimeout(() => {
          startRound();
        }, DEAL_MS); // wait 3s, then new round
      }
      return rest;
    });
  }, [step]);

  /** Auto-start once on mount */
  useEffect(() => {
    startRound();
    return () => {
      clearInterval(dealIntervalRef.current);
      clearInterval(countdownIntervalRef.current);
      clearTimeout(restartTimeoutRef.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /** ---- SVG circular timer calculations ---- **/
  const R = 45; // circle r=45 (matches your SVG)
  const CIRC = 2 * Math.PI * R; // ~282.743
  const frac = Math.max(0, Math.min(1, timeLeft / DEAL_MS));
  const dash = Math.max(0.0001, CIRC * frac); // visible arc length
  const label = Math.ceil(timeLeft / 1000); // 3..2..1..

  //console.log("resultList:", resultList);

  return (
    <div className="access-aaa player-scope card32-scope">
      <ClientLayoutWithOutHeader showLoader={false}>
        <div class="details-tabs-wrapper1">
          <div className="main-page">
            <div className="row no-gutters">
              <div className="col-md-12">
                <div className="bodyheight">
                  <div className="wrapper">
                    <TPStudioSidebar open={open} />
                  </div>

                  <div className="lobby-ctn BPGmaindiv">
                    <TpStudioHeader setOpen={setOpen} open={open} />
                    <TpStudioLoader displayLoader={displayLoader} />
                  </div>
                  <div
                    className="ExMainCardbundle lobby-ctn BPGmaindiv card32-main-div"
                    style={{ display: displayLoader ? "none" : "" }}
                  >
                    <div className="right-side-wrapper-row" id="afterAnimation">
                      <div className="row right-side-row">
                        <div className="col-md-12 padding-none-wrapper1">
                          <div className="left-content">
                            <div className="table-wrap">
                              <div className="details-tabs-wrapper1">
                                <div className="row">
                                  <div className="col-md-8">
                                    {/*- -*/}
                                    <div className="table-box-header2">
                                      <div className="row no-gutters">
                                        <div
                                          className="col-6"
                                          style={{ color: "white" }}
                                        >
                                          <strong>32 CARDS</strong>
                                        </div>
                                        <div
                                          className="col-6"
                                          style={{
                                            color: "white",
                                            textAlign: "right"
                                          }}
                                        >
                                          <div
                                            role="group"
                                            aria-label="Second group"
                                            className="btn-group btn-group-sm mr-2"
                                          >
                                            <button
                                              type="button"
                                              id="Alltab"
                                              className={
                                                activeTabIndex == 1
                                                  ? "tablink btn btn-primary bbactive"
                                                  : "tablink btn btn-primary"
                                              }
                                              onClick={() => activeTab(1)}
                                            >
                                              Game
                                            </button>
                                            <button
                                              type="button"
                                              id="RESULTStab"
                                              className={
                                                activeTabIndex == 2
                                                  ? "tablink btn btn-primary bbactive"
                                                  : "tablink btn btn-primary"
                                              }
                                              onClick={() => activeTab(2)}
                                            >
                                              Results
                                            </button>
                                            <button
                                              type="button"
                                              className="tablink btn btn-primary"
                                              onClick={() => setShowRules(true)}
                                            >
                                              Rules
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <Card32Rules
                                      show={showRules}
                                      onClose={() => setShowRules(false)}
                                    />
                                    {/*- -*/}
                                    <span
                                      id="AlltabData"
                                      style={{
                                        display:
                                          activeTabIndex == 1 ? "" : "none"
                                      }}
                                    >
                                      <div
                                        className="collapse show card32-gradient mobile-height"
                                        aria-labelledby="headingThree"
                                        data-parent="#video"
                                        style={{
                                          textAlign: "center",
                                          padding: "0 0 10px 0",
                                          border: "solid 1px #130a21",
                                          position: "relative"
                                        }}
                                      >
                                        <div className="card32-timer-row">
                                          <div className="Connectedclients mt-1">
                                            <i
                                              aria-hidden="true"
                                              className="fa fa-user mr-1"
                                              style={{
                                                fontSize: "14px",
                                                color: "white"
                                              }}
                                            />
                                            <b>
                                              <span className="number">
                                                326
                                              </span>
                                            </b>
                                          </div>
                                          <div class="base-timer">
                                            <svg
                                              viewBox="0 0 100 100"
                                              xmlns="http://www.w3.org/2000/svg"
                                              class="base-timer__svg"
                                            >
                                              <g class="base-timer__circle">
                                                <circle
                                                  cx="50"
                                                  cy="50"
                                                  r="45"
                                                  class="base-timer__path-elapsed"
                                                ></circle>{" "}
                                                <path
                                                  id="base-timer-path-remaining"
                                                  stroke-dasharray="118 283"
                                                  d="
                                                                  M 50, 50
                                                                  m -45, 0
                                                                  a 45,45 0 1,0 90,0
                                                                  a 45,45 0 1,0 -90,0
                                                                "
                                                  class="base-timer__path-remaining ${remainingPathColor} green"
                                                ></path>
                                              </g>
                                            </svg>{" "}
                                            <span
                                              id="base-timer-label"
                                              class="base-timer__label absolute"
                                            >
                                              {timeLeftGame}
                                            </span>
                                          </div>
                                        </div>
                                        <div className="card32-players">
                                          <div
                                            class="player"
                                            style={{ display: "inline-flex" }}
                                          >
                                            <div class="card32-player-item">
                                              <span class="name">
                                                Player 8{" "}
                                              </span>
                                              <div class="card32-player-card  stood">
                                                <div class="header-title">
                                                  <span class="status"></span>
                                                </div>
                                                <div
                                                  id="BFBCardHandView"
                                                  class="card32-BFBCardHandView"
                                                >
                                                  <div
                                                    id="game-cards1"
                                                    class="BFBCardFanView"
                                                  >
                                                    {cards_desc &&
                                                      c1Img &&
                                                      visibleCards >= 1 &&
                                                      (() => {
                                                        let cardImage = `../assets/galaxy/img/cards3/${c1Img}.svg`;
                                                        return (
                                                          <div
                                                            id="BFBCardView"
                                                            class="card1"
                                                          >
                                                            <img
                                                              id="RSMImageView"
                                                              src={cardImage}
                                                              class="RSMImageView animate__animated"
                                                            />
                                                          </div>
                                                        );
                                                      })()}
                                                  </div>
                                                </div>
                                              </div>
                                              <div class="card32-player-card-footer  stood">
                                                <span class="name">
                                                  8 + {cardNum1} = {c1}
                                                </span>
                                              </div>
                                            </div>
                                          </div>
                                          <div
                                            class="player"
                                            style={{ display: "inline-flex" }}
                                          >
                                            <div class="card32-player-item">
                                              <span class="name">Player 9</span>
                                              <div class="card32-player-card  stood">
                                                <div class="header-title">
                                                  <span class="status"></span>
                                                </div>
                                                <div
                                                  id="BFBCardHandView"
                                                  class="card32-BFBCardHandView"
                                                >
                                                  <div
                                                    id="game-cards2"
                                                    class="BFBCardFanView"
                                                  >
                                                    {cards_desc &&
                                                      c2Img &&
                                                      visibleCards >= 2 &&
                                                      (() => {
                                                        let cardImage = `../assets/galaxy/img/cards3/${c2Img}.svg`;
                                                        return (
                                                          <div
                                                            id="BFBCardView"
                                                            class="card1"
                                                          >
                                                            <img
                                                              id="RSMImageView"
                                                              src={cardImage}
                                                              class="RSMImageView animate__animated"
                                                            />
                                                          </div>
                                                        );
                                                      })()}
                                                  </div>
                                                </div>
                                              </div>
                                              <div class="card32-player-card-footer stood">
                                                <span class="name" id="sum1">
                                                  9 + {cardNum2} = {c2}
                                                </span>
                                              </div>
                                            </div>
                                          </div>
                                          <div
                                            class="player"
                                            style={{ display: "inline-flex" }}
                                          >
                                            <div class="card32-player-item">
                                              <span class="name">
                                                Player 10
                                              </span>
                                              <div class="card32-player-card  stood">
                                                <div class="header-title">
                                                  <span class="status"></span>
                                                </div>
                                                <div
                                                  id="BFBCardHandView"
                                                  class="card32-BFBCardHandView"
                                                >
                                                  <div
                                                    id="game-cards3"
                                                    class="card32-BFBCardFanView"
                                                  >
                                                    {cards_desc &&
                                                      c3Img &&
                                                      visibleCards >= 3 &&
                                                      (() => {
                                                        let cardImage = `../assets/galaxy/img/cards3/${c3Img}.svg`;
                                                        return (
                                                          <div
                                                            id="BFBCardView"
                                                            class="card1"
                                                          >
                                                            <img
                                                              id="RSMImageView"
                                                              src={cardImage}
                                                              class="RSMImageView animate__animated"
                                                            />
                                                          </div>
                                                        );
                                                      })()}
                                                  </div>
                                                </div>
                                              </div>
                                              <div class="card32-player-card-footer  stood">
                                                <span class="name" id="sum1">
                                                  10 + {cardNum3} = {c3}
                                                </span>
                                              </div>
                                            </div>
                                          </div>
                                          <div
                                            class="player"
                                            style={{ display: "inline-flex" }}
                                          >
                                            <div class="card32-player-item">
                                              <span class="name">
                                                Player 11
                                              </span>
                                              <div class="card32-player-card  stood">
                                                <div class="header-title">
                                                  <span class="status"></span>
                                                </div>
                                                <div
                                                  id="BFBCardHandView"
                                                  class="card32-BFBCardHandView"
                                                >
                                                  <div
                                                    id="game-cards4"
                                                    class="card32-BFBCardFanView"
                                                  >
                                                    {cards_desc &&
                                                      c4Img &&
                                                      visibleCards >= 4 &&
                                                      (() => {
                                                        let cardImage = `../assets/galaxy/img/cards3/${c4Img}.svg`;
                                                        return (
                                                          <div
                                                            id="BFBCardView"
                                                            class="card1"
                                                          >
                                                            <img
                                                              id="RSMImageView"
                                                              src={cardImage}
                                                              class="RSMImageView animate__animated"
                                                            />
                                                          </div>
                                                        );
                                                      })()}
                                                  </div>
                                                </div>
                                              </div>
                                              <div class="card32-player-card-footer  stood">
                                                <span class="name" id="sum1">
                                                  11 + {cardNum4} = {c4}
                                                </span>
                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                        <div className="card32-volume-row">
                                          <div className="volume-wrapper">
                                            <Volume id="Card32Soundcontrol" />
                                          </div>
                                        </div>
                                      </div>
                                      {/*- -*/}

                                      {/* Footer */}
                                      <div
                                        style={{
                                          display:
                                            activeTabIndex == 1 ? "" : "none"
                                        }}
                                      >
                                        <div className="footer-divbpg border-gradient-footer border-gradient-purple-footer">
                                          <div className="video-button">
                                            {Object.keys(resultList).map(
                                              (idx) => (
                                                <button
                                                  key={idx}
                                                  className="video-button border-gradient-btn border-gradient-purple-btn"
                                                >
                                                  {resultList[idx]}
                                                </button>
                                              )
                                            )}
                                          </div>
                                          <div className="round-div">
                                            <div className="label">
                                              Round ID:
                                            </div>
                                            <div className="id">{roundId}</div>
                                          </div>
                                        </div>
                                      </div>

                                      <div
                                        className="tb-content"
                                        style={{ background: "#fff" }}
                                      >
                                        <div className="market-titlebar">
                                          <p className="market-name">
                                            <span className="market-name-badge">
                                              <i className="market-name-icon">
                                                <img
                                                  src="/assets/images/time-img.png"
                                                  style={{
                                                    filter: "invert(100%)",
                                                    marginTop: "-8px",
                                                    marginLeft: "-1px"
                                                  }}
                                                />
                                              </i>
                                              <span>MAIN </span>
                                              {/*-<span style="text-transform: initial;">
                                                          (MaxBet: 5M) </span></span> <span class="rules-badge"><i class="fa fa-info-circle"></i></span>-*/}
                                            </span>
                                          </p>
                                          <div className="market-overarround">
                                            <span />
                                            <strong>Back</strong>
                                          </div>
                                          <div className="market-overarround market-overarround-lay">
                                            <strong>Lay</strong>
                                          </div>
                                        </div>
                                        <div className="market-runners">
                                          <div className="runner-runner">
                                            <h3
                                              className={
                                                player8Winner && cardsSettled
                                                  ? "runner-name sussesBg"
                                                  : "runner-name"
                                              }
                                              id="b1Sucess"
                                            >
                                              <div className="runner-info">
                                                <span className="clippable runner-display-name">
                                                  <table>
                                                    <tbody>
                                                      <tr>
                                                        <td>
                                                          <h4
                                                            style={{
                                                              marginBottom: 0,
                                                              fontSize: 16
                                                            }}
                                                            className="clippable-spacer"
                                                          >
                                                            Player 8
                                                          </h4>
                                                        </td>
                                                      </tr>
                                                      <tr>
                                                        <td>
                                                          <div
                                                            id="livestat1"
                                                            style={{
                                                              float: "left",
                                                              color: "red"
                                                            }}
                                                          >
                                                            {book1 !== "" ? (
                                                              Number(book1) >
                                                              0 ? (
                                                                <font color="green">
                                                                  {formatTruncate(
                                                                    book1
                                                                  )}
                                                                </font>
                                                              ) : (
                                                                <font color="red">
                                                                  {formatTruncate(
                                                                    book1
                                                                  )}
                                                                </font>
                                                              )
                                                            ) : (
                                                              ""
                                                            )}
                                                          </div>
                                                        </td>
                                                      </tr>
                                                    </tbody>
                                                  </table>
                                                </span>
                                              </div>
                                            </h3>
                                            <div className="price-row-box-new">
                                              <div
                                                className={`runner-disabled2 suspendCls ${
                                                  isSuspended ? "" : "hides"
                                                }`}
                                              >
                                                {suspendedText}
                                              </div>
                                              <a className="price-price price-back whtBack d-none d-sm-block">
                                                <div>&nbsp;</div>
                                              </a>
                                              <a className="price-price price-back whtBack d-none d-sm-block">
                                                <div>&nbsp;</div>
                                              </a>
                                              <a
                                                className="price-price price-back mb-show span1details"
                                                data-id="Amar"
                                                data-type="b"
                                                data-sid={1}
                                                data-market-type="m"
                                                onClick={() =>
                                                  showBetfairBetSlip(
                                                    "b",
                                                    "Player 8",
                                                    b1
                                                  )
                                                }
                                              >
                                                <div
                                                  id="rnr1"
                                                  className="sus_cls"
                                                >
                                                  <span
                                                    className="price-odd odd"
                                                    id="s01"
                                                  >
                                                    <span>{b1}</span>
                                                  </span>
                                                  <span
                                                    className="price-amount"
                                                    id="rate1"
                                                  >
                                                    {stakeLimit}
                                                  </span>
                                                </div>
                                              </a>
                                              <a
                                                className="price-price price-lay ml-4 mb-show"
                                                onClick={() =>
                                                  showBetfairBetSlip(
                                                    "l",
                                                    "Player 8",
                                                    l1
                                                  )
                                                }
                                              >
                                                <div
                                                  id="rnr1"
                                                  className="sus_cls"
                                                >
                                                  <span
                                                    className="price-odd odd"
                                                    id="s01"
                                                  >
                                                    <span>{l1}</span>
                                                  </span>
                                                  <span
                                                    className="price-amount"
                                                    id="rate1"
                                                  >
                                                    {stakeLimit}
                                                  </span>
                                                </div>
                                              </a>
                                              <a className="price-price price-lay whtBack d-none d-sm-block">
                                                <div>&nbsp;</div>
                                              </a>
                                              <a className="price-price price-lay mr-4 whtBack d-none d-sm-block">
                                                <div>&nbsp;</div>
                                              </a>
                                              {/*<div class="suspended-overlap" id="odds_suspend_runner1">Suspended</div>*/}
                                            </div>
                                          </div>
                                          <div className="runner-runner">
                                            <h3
                                              className={
                                                player9Winner && cardsSettled
                                                  ? "runner-name sussesBg"
                                                  : "runner-name"
                                              }
                                              id="b1Sucess"
                                            >
                                              <div className="runner-info">
                                                <span className="clippable runner-display-name">
                                                  <table>
                                                    <tbody>
                                                      <tr>
                                                        <td>
                                                          <h4
                                                            style={{
                                                              marginBottom: 0,
                                                              fontSize: 16
                                                            }}
                                                            className="clippable-spacer"
                                                          >
                                                            Player 9
                                                          </h4>
                                                        </td>
                                                      </tr>
                                                      <tr>
                                                        <td>
                                                          <div
                                                            id="livestat2"
                                                            style={{
                                                              float: "left",
                                                              color: "red"
                                                            }}
                                                          >
                                                            {book2 !== "" ? (
                                                              Number(book2) >
                                                              0 ? (
                                                                <font color="green">
                                                                  {formatTruncate(
                                                                    book2
                                                                  )}
                                                                </font>
                                                              ) : (
                                                                <font color="red">
                                                                  {formatTruncate(
                                                                    book2
                                                                  )}
                                                                </font>
                                                              )
                                                            ) : (
                                                              ""
                                                            )}
                                                          </div>
                                                        </td>
                                                      </tr>
                                                    </tbody>
                                                  </table>
                                                  {/*<span class="favi" id="runner2_fav"
                                                                  style="display:none;padding:3px 7px;border-radius:10px;background:#e2b330;color:white">F</span>*/}
                                                </span>
                                              </div>
                                            </h3>
                                            <div className="price-row-box-new">
                                              <div
                                                className={`runner-disabled2 suspendCls ${
                                                  isSuspended ? "" : "hides"
                                                }`}
                                              >
                                                {suspendedText}
                                              </div>
                                              <a className="price-price price-back whtBack d-none d-sm-block">
                                                <div>&nbsp;</div>
                                              </a>
                                              <a className="price-price price-back whtBack d-none d-sm-block">
                                                <div>&nbsp;</div>
                                              </a>
                                              <a
                                                className="price-price price-back mb-show span1details"
                                                data-market-type="m"
                                                data-id="Akbar"
                                                data-type="b"
                                                data-sid={2}
                                                onClick={() =>
                                                  showBetfairBetSlip(
                                                    "b",
                                                    "Player 9",
                                                    b2
                                                  )
                                                }
                                              >
                                                <div
                                                  id="rnr2"
                                                  className="sus_cls"
                                                >
                                                  <span
                                                    className="price-odd odd"
                                                    id="s03"
                                                  >
                                                    <span>{b2}</span>
                                                  </span>
                                                  <span
                                                    className="price-amount"
                                                    id="rate2"
                                                  >
                                                    {stakeLimit}
                                                  </span>
                                                </div>
                                              </a>
                                              <a
                                                className="price-price price-lay ml-4 mb-show"
                                                onClick={() =>
                                                  showBetfairBetSlip(
                                                    "l",
                                                    "Player 9",
                                                    l2
                                                  )
                                                }
                                              >
                                                <div
                                                  id="rnr2"
                                                  className="sus_cls"
                                                >
                                                  <span
                                                    className="price-odd odd"
                                                    id="s03"
                                                  >
                                                    <span>{l2}</span>
                                                  </span>
                                                  <span
                                                    className="price-amount"
                                                    id="rate2"
                                                  >
                                                    {stakeLimit}
                                                  </span>
                                                </div>
                                              </a>
                                              <a className="price-price price-lay whtBack d-none d-sm-block">
                                                <div>&nbsp;</div>
                                              </a>
                                              <a className="price-price price-lay mr-4 whtBack d-none d-sm-block">
                                                <div>&nbsp;</div>
                                              </a>
                                            </div>
                                          </div>
                                          <div className="runner-runner">
                                            <h3
                                              className={
                                                player10Winner && cardsSettled
                                                  ? "runner-name sussesBg"
                                                  : "runner-name"
                                              }
                                              id="b1Sucess"
                                            >
                                              <div className="runner-info">
                                                <span className="clippable runner-display-name">
                                                  <table>
                                                    <tbody>
                                                      <tr>
                                                        <td>
                                                          <h4
                                                            style={{
                                                              marginBottom: 0,
                                                              fontSize: 16
                                                            }}
                                                            className="clippable-spacer"
                                                          >
                                                            Player 10
                                                          </h4>
                                                        </td>
                                                      </tr>
                                                      <tr>
                                                        <td>
                                                          <div
                                                            id="livestat3"
                                                            style={{
                                                              float: "left",
                                                              color: "red"
                                                            }}
                                                          >
                                                            {book3 !== "" ? (
                                                              Number(book3) >
                                                              0 ? (
                                                                <font color="green">
                                                                  {formatTruncate(
                                                                    book3
                                                                  )}
                                                                </font>
                                                              ) : (
                                                                <font color="red">
                                                                  {formatTruncate(
                                                                    book3
                                                                  )}
                                                                </font>
                                                              )
                                                            ) : (
                                                              ""
                                                            )}
                                                          </div>
                                                        </td>
                                                      </tr>
                                                    </tbody>
                                                  </table>
                                                </span>
                                              </div>
                                            </h3>
                                            <div className="price-row-box-new">
                                              <div
                                                className={`runner-disabled2 suspendCls ${
                                                  isSuspended ? "" : "hides"
                                                }`}
                                              >
                                                {suspendedText}
                                              </div>
                                              <a className="price-price price-back whtBack d-none d-sm-block">
                                                <div>&nbsp;</div>
                                              </a>
                                              <a className="price-price price-back whtBack d-none d-sm-block">
                                                <div>&nbsp;</div>
                                              </a>
                                              <a
                                                className="price-price price-back mb-show span1details"
                                                data-id="Anthony"
                                                data-type="b"
                                                data-sid={3}
                                                data-market-type="m"
                                                onClick={() =>
                                                  showBetfairBetSlip(
                                                    "b",
                                                    "Player 10",
                                                    b3
                                                  )
                                                }
                                              >
                                                <div
                                                  id="rnr3"
                                                  className="sus_cls"
                                                >
                                                  <span
                                                    className="price-odd odd"
                                                    id="s05"
                                                  >
                                                    <span>{b3}</span>
                                                  </span>
                                                  <span
                                                    className="price-amount"
                                                    id="rate3"
                                                  >
                                                    {stakeLimit}
                                                  </span>
                                                </div>
                                              </a>
                                              <a
                                                className="price-price price-lay ml-4 mb-show"
                                                onClick={() =>
                                                  showBetfairBetSlip(
                                                    "l",
                                                    "Player 10",
                                                    l3
                                                  )
                                                }
                                              >
                                                <div
                                                  id="rnr3"
                                                  className="sus_cls"
                                                >
                                                  <span
                                                    className="price-odd odd"
                                                    id="s05"
                                                  >
                                                    <span>{l3}</span>
                                                  </span>
                                                  <span
                                                    className="price-amount"
                                                    id="rate3"
                                                  >
                                                    {stakeLimit}
                                                  </span>
                                                </div>
                                              </a>
                                              <a className="price-price price-lay whtBack d-none d-sm-block">
                                                <div>&nbsp;</div>
                                              </a>
                                              <a className="price-price price-lay mr-4 whtBack d-none d-sm-block">
                                                <div>&nbsp;</div>
                                              </a>
                                              {/*<div class="suspended-overlap" id="odds_suspend_runner2">Suspended</div>*/}
                                            </div>
                                          </div>
                                          <div className="runner-runner">
                                            <h3
                                              className={
                                                player11Winner && cardsSettled
                                                  ? "runner-name sussesBg"
                                                  : "runner-name"
                                              }
                                              id="b1Sucess"
                                            >
                                              <div className="runner-info">
                                                <span className="clippable runner-display-name">
                                                  <table>
                                                    <tbody>
                                                      <tr>
                                                        <td>
                                                          <h4
                                                            style={{
                                                              marginBottom: 0,
                                                              fontSize: 16
                                                            }}
                                                            className="clippable-spacer"
                                                          >
                                                            Player 11
                                                          </h4>
                                                        </td>
                                                      </tr>
                                                      <tr>
                                                        <td>
                                                          <div
                                                            id="livestat5"
                                                            style={{
                                                              float: "left",
                                                              color: "red"
                                                            }}
                                                          >
                                                            {book4 !== "" ? (
                                                              Number(book4) >
                                                              0 ? (
                                                                <font color="green">
                                                                  {formatTruncate(
                                                                    book4
                                                                  )}
                                                                </font>
                                                              ) : (
                                                                <font color="red">
                                                                  {formatTruncate(
                                                                    book4
                                                                  )}
                                                                </font>
                                                              )
                                                            ) : (
                                                              ""
                                                            )}
                                                          </div>
                                                        </td>
                                                      </tr>
                                                    </tbody>
                                                  </table>
                                                </span>
                                              </div>
                                            </h3>
                                            <div className="price-row-box-new">
                                              <div
                                                className={`runner-disabled2 suspendCls ${
                                                  isSuspended ? "" : "hides"
                                                }`}
                                              >
                                                {suspendedText}
                                              </div>
                                              <a className="price-price price-back whtBack d-none d-sm-block">
                                                <div>&nbsp;</div>
                                              </a>
                                              <a className="price-price price-back whtBack d-none d-sm-block">
                                                <div>&nbsp;</div>
                                              </a>
                                              <a
                                                className="price-price price-back mb-show span1details"
                                                data-id="Odd"
                                                data-type="b"
                                                data-sid={5}
                                                data-market-type="f"
                                                onClick={() =>
                                                  showBetfairBetSlip(
                                                    "b",
                                                    "Player 11",
                                                    b4
                                                  )
                                                }
                                              >
                                                <div
                                                  id="rnr4"
                                                  className="sus_cls"
                                                >
                                                  <span
                                                    className="price-odd odd"
                                                    id="s08"
                                                  >
                                                    <span>{b4}</span>
                                                  </span>
                                                  <span
                                                    className="price-amount"
                                                    id="rate4"
                                                  >
                                                    {stakeLimit}
                                                  </span>
                                                </div>
                                              </a>
                                              <a
                                                className="price-price price-lay ml-4 mb-show"
                                                onClick={() =>
                                                  showBetfairBetSlip(
                                                    "l",
                                                    "Player 11",
                                                    l4
                                                  )
                                                }
                                              >
                                                <div
                                                  id="rnr4"
                                                  className="sus_cls"
                                                >
                                                  <span
                                                    className="price-odd odd"
                                                    id="s08"
                                                  >
                                                    <span>{l4}</span>
                                                  </span>
                                                  <span
                                                    className="price-amount"
                                                    id="rate4"
                                                  >
                                                    {stakeLimit}
                                                  </span>
                                                </div>
                                              </a>
                                              <a className="price-price price-lay whtBack d-none d-sm-block">
                                                <div>&nbsp;</div>
                                              </a>
                                              <a className="price-price price-lay mr-4 whtBack d-none d-sm-block">
                                                <div>&nbsp;</div>
                                              </a>
                                              {/*<div class="suspended-overlap" id="odds_suspend_runner1">Suspended</div>*/}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </span>

                                    <div
                                      style={{
                                        display:
                                          activeTabIndex == 2 ? "" : "none",
                                        color: "white"
                                      }}
                                    >
                                      <Card32Result resultData={resultData} />
                                    </div>
                                    <div
                                      id="ResultsData"
                                      className="tabcontent"
                                      style={{ display: "none" }}
                                    ></div>
                                  </div>
                                  <div className="col-md-4">
                                    <div
                                      className="accordion"
                                      id="bookmakerExample"
                                      style={{ marginTop: 0, marginBottom: 5 }}
                                    >
                                      <div
                                        className="card"
                                        style={{ border: 0 }}
                                      >
                                        {showBetSlipPopup && (
                                          <TPPopUpBetSlip
                                            closeBetSlipParent={
                                              closeBetSlipMobile
                                            }
                                            betObj={placeBetObject}
                                            placeBetParent={placeBet}
                                            betButtonShow={betButtonShow}
                                            betErrorMessageObj={
                                              betErrorMessageObj
                                            }
                                            betButtonShowLoaderShow={
                                              betButtonShowLoaderShow
                                            }
                                            profileData={profileData}
                                          />
                                        )}

                                        <TeenPattisCasinoBetslipWeb
                                          showBetSlip={showBetSlip}
                                          placeBetObject={placeBetObject}
                                          closeBetSlipParent={closeBetSlip}
                                          placeBetParent={placeBet}
                                          betErrorMessageObj={
                                            betErrorMessageObj
                                          }
                                          profileData={profileData}
                                        ></TeenPattisCasinoBetslipWeb>

                                        <div
                                          className="card-header"
                                          id="headingTwo"
                                          style={{
                                            padding: 0,
                                            background: "#23292d"
                                          }}
                                        >
                                          <h2
                                            className="mb-0"
                                            style={{
                                              background: "var(--theme-color)",
                                              borderRadius: 0
                                            }}
                                          >
                                            <button
                                              className="btn btn-link btn-block text-left"
                                              type="button"
                                              data-toggle="collapse"
                                              data-target="#collapseTwo"
                                              aria-expanded="true"
                                              aria-controls="collapseTwo"
                                              style={{
                                                color: "white",
                                                textDecoration: "none"
                                              }}
                                            >
                                              Matched Bets
                                            </button>
                                          </h2>
                                        </div>

                                        <div
                                          id="collapseTwo"
                                          className="collapse show"
                                          aria-labelledby="headingTwo"
                                          data-parent="#bookmakerExample"
                                          style={{ backgroundColor: "#2e3438" }}
                                        >
                                          <div
                                            className="card-body"
                                            style={{
                                              padding: 0,
                                              minHeight: 40
                                            }}
                                          >
                                            <div
                                              id="refreshhistory"
                                              style={{
                                                paddingLeft: 0,
                                                width: "100%"
                                              }}
                                            >
                                              <table
                                                className="table"
                                                style={{ marginBottom: 0 }}
                                              >
                                                <thead>
                                                  <tr>
                                                    <th>Runner</th>
                                                    <th>Price</th>
                                                    <th>Size</th>
                                                    <th></th>
                                                  </tr>
                                                </thead>
                                                <tbody>
                                                  {betList.length > 0 ? (
                                                    betList.map(
                                                      (item, index) => (
                                                        <tr
                                                          style={{
                                                            background:
                                                              item.type == "b"
                                                                ? "#e9f6fc"
                                                                : "#fce3e4",
                                                            color: "#000",
                                                            fontSize: "15px",
                                                            textAlign: "center"
                                                          }}
                                                        >
                                                          <td
                                                            style={{
                                                              textAlign: "left",
                                                              padding: "15px",
                                                              display:
                                                                "table-cell",
                                                              padding: "5px"
                                                            }}
                                                          >
                                                            {item.rnr !== "" ? (
                                                              item.rnr ==
                                                                "b1" ||
                                                              item.rnr ==
                                                                "l1" ? (
                                                                <span>
                                                                  Player 8
                                                                </span>
                                                              ) : item.rnr ==
                                                                  "b2" ||
                                                                item.rnr ==
                                                                  "l2" ? (
                                                                <span>
                                                                  Player 9
                                                                </span>
                                                              ) : item.rnr ==
                                                                  "b3" ||
                                                                item.rnr ==
                                                                  "l3" ? (
                                                                <span>
                                                                  Player 10
                                                                </span>
                                                              ) : item.rnr ==
                                                                  "b4" ||
                                                                item.rnr ==
                                                                  "l4" ? (
                                                                <span>
                                                                  Player 11
                                                                </span>
                                                              ) : (
                                                                <span></span> // For any other value
                                                              )
                                                            ) : (
                                                              <span></span>
                                                            )}
                                                            - {item.cat_mid}
                                                          </td>
                                                          <td
                                                            style={{
                                                              display:
                                                                "table-cell",
                                                              textAlign: "left",
                                                              padding: "5px"
                                                            }}
                                                          >
                                                            {item.rate}
                                                          </td>
                                                          <td
                                                            style={{
                                                              display:
                                                                "table-cell",
                                                              textAlign: "left",
                                                              padding: "5px"
                                                            }}
                                                          >
                                                            {item.amnt}
                                                          </td>
                                                          <td></td>
                                                        </tr>
                                                      )
                                                    )
                                                  ) : (
                                                    <tr></tr>
                                                  )}
                                                </tbody>
                                              </table>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      {/* Open bets end*/}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ClientLayoutWithOutHeader>
      <style>
        {`

.ExMainCardbundle .runner-runner .price-price.price-lay.ml-4.mb-show {
    background-color: #f8d2d3 !important;
}
    
          @media (max-width: 768px) {
          .footer-divbpg > .video-button {
              display: flex;
              flex-wrap: nowrap;
          }

          .footer-divbpg > .video-button button {
              display: none;
          }

          .footer-divbpg > .video-button button:nth-last-child(-n+5) {
              display: block;
          }
      }

      .footer-divbpg {
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 100%;  
          box-sizing: border-box;
          background: linear-gradient(
              to bottom,
              #4b4b4b 0%,
              #2f2f2f 30%,
              #1d1d1d 60%,
              #101010 100%
          );
      }
              .border-gradient-footer {
              border-top: 2px solid transparent;
              border-bottom: 2px solid transparent;
              border-left:  2px solid transparent;
              border-right:  2px solid transparent;

              border-image-slice: 1;
          }
              .border-gradient-purple-footer {
              border-image-source: linear-gradient(
                  180deg,
                  rgba(207, 141, 46, .47),
                  #cf8d2e 50%,
                  rgba(207, 141, 46, .47)
              );
          }

          .card32-scope .col-12,
              .card32-scope .col-md-8,
              .card32-scope .col-md-4 {
                  padding-left: 9px !important;
                  padding-right: 6px !important;
              }

          .card32-scope .card32-gradient {
              position: relative;
              background: #000 !important;
              overflow: hidden;
          }

          .card32-scope .card32-gradient::before {
              content: "";
              position: absolute;
              top: 0;
              right: 0;
              bottom: 0;
              left: 0;
              background: radial-gradient(
                ellipse 100% 44% at 50% 30%,
                rgba(62, 193, 65, 0.95) 0%,
                rgba(62, 193, 65, 0.8) 15%,
                rgba(30, 80, 35, 0.5) 40%,
                #1e1e1e 55%,
                #1e1e1e 100%
              );
              opacity: 0.4;
              pointer-events: none;
              z-index: 0;
          }

          .card32-scope .card32-gradient > * {
              position: relative;
              z-index: 1;
          }

          .card32-scope .card32-timer-row {
              display: flex;
              align-items: center;
              justify-content: space-between;
              padding: 10px 12px;
          }

        .footer-divbpg .video-button {
            background-color: #4f4f4f;
            color: #fff;
            font-family: Roboto Condensed;
            font-size: 10px;
            font-style: normal;
            font-weight: 500;
            height: 30px;
            margin-right: 3px;
            min-width: 40px;
            padding: 0;
            pointer-events: none;
            width: auto;
        }

            .border-gradient-purple-footer {
        border-image-source: linear-gradient(180deg, #cf8d2e78, #cf8d2e 50%, #cf8d2e78);
    }

          .footer-divbpg {
        background: linear-gradient(180deg, #464646, #0f0f0f);
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }
          .card32-scope .card32-timer-row .Connectedclients {
              position: relative;
              top: -10px;
              margin: 0;
              opacity: 0.9;
              z-index: 1000;
              float: none;
              width: auto;
              display: inline-flex;
              align-items: center;
              background: rgba(255, 255, 255, 0.1);
              backdrop-filter: blur(8px);
              padding: 0 8px;
              border-radius: 15px;
              border-right: 1px solid #fff;
              border-bottom: 1px solid #fff;
          }

          .card32-scope .card32-timer-row .Connectedclients b,
          .card32-scope .card32-timer-row .Connectedclients .number {
              color: #fff !important;
              font-size: 14px;
          }

          .card32-scope .card32-volume-row {
              position: absolute;
              right: 12px;
              bottom: 8px;
              padding: 0;
              margin: 0;
              z-index: 1001;
              display: flex;
              align-items: center;
              justify-content: flex-end;
          }

          .card32-scope .card32-volume-row .volume-wrapper {
              position: relative;
              z-index: 1001;
              margin: 0;
              text-align: right;
          }

          .card32-scope .card32-volume-row .volume-wrapper .sound-icon {
              position: relative;
              top: 0;
              right: auto;
              left: auto;
              transform: scale(0.8);
              transform-origin: center;
          }

          .card32-scope .card32-players {
              display: flex !important;
              justify-content: center !important;
              align-items: flex-start;
              flex-wrap: nowrap;
              gap: 10px !important;
              width: 100%;
          }

          .card32-scope .card32-players > .player {
              margin: 0 !important;
              flex: 0 0 auto !important;
              width: auto !important;
              display: inline-flex !important;
          }

          .card32-scope .card32-player-item {
              width: auto;
          }

          .card32-scope .card32-player-card {
              width: 200px !important;
          }
                


          @media (max-width: 767.98px) {
            .card32-scope .card32-gradient {
              overflow: visible !important;
            }

            .card32-scope .card32-gradient.mobile-height {
              height: auto !important;
              min-height: 300px;
              padding-bottom: 0 !important;
            }

            .card32-scope .card32-players {
              display: grid !important;
              grid-template-columns: repeat(2, 1fr);
              gap: 10px !important;
              width: 80%;
              max-width: 80%;
              margin-top: 10px;
              margin-left: 10%;
              margin-right: 10%;
              padding: 0;
              box-sizing: border-box;
              justify-content: center;
            }

            .card32-scope .card32-players > .player {
              width: 100% !important;
              display: flex !important;
              justify-content: center;
            }

            .card32-scope .card32-player-item {
              width: 100%;
              padding-bottom: 4px;
            }

            .card32-scope .card32-player-card {
              width: 100% !important;
              max-width: 100%;
              height: 75px !important;
              min-height: 75px !important;
              overflow: hidden;
            }

            .card32-scope .card32-BFBCardHandView {
              width: 100% !important;
              max-width: 100%;
              height: 55px !important;
              margin-top: 0 !important;
              margin-bottom: 0 !important;
              overflow: hidden;
              position: relative;
            }

            .card32-scope .card32-BFBCardFanView {
              width: 100%;
              height: 100%;
              position: relative;
            }

            .card32-scope .card32-players .card1 {
              position: absolute;
              left: 50% !important;
              top: 50% !important;
              transform: translate(-50%, -50%) !important;
              width: 42px !important;
              height: 58px !important;
              transform-origin: center center;
            }

            .card32-scope .card32-players .RSMImageView.animate__animated {
              width: 100% !important;
              height: auto !important;
              max-height: 58px;
              margin: 10px !important;
            }
          }

         .player {
              margin: 4px;
              display: inline-block;
              justify-content: space-between;
              flex: 1 0 0;
              flex-wrap: wrap;
          }
          .player-item {
              margin-bottom: 16px;
              display: block;
              margin-right: 0;
              z-index: 0;
          }
          .player-item .name {
              display: block;
              color: #d7bc7b;
              font-size: 12px;
              font-weight: 700;
              padding-bottom: 5px;
              text-align: center;
          }
          .player-item .player-card {
              border-radius: 12px;
              border: 1px solid rgba(178, 220, 175, .25);
          }
          .BFBCardHandView {
              transform: translate3d(0, 0, 0);
              width: 160px;
              height: 105px;
              margin-top: 5px;
              margin-bottom: 5px;
          }
          #refreshhistory .table thead th {
              padding: 5px;
              color: #2b2f35;
              background: #ddd;
          }

          @media(max-width:576px){

              .card32-scope .col-md-8,{
                  padding-left: 10px !important;
                  padding-right: 10px !important;
              }
            .RSMImageView {
              width: 50%;
              height: 35% !important;
              margin-top: -5px;
            }
            .card32-scope .card32-players .RSMImageView.animate__animated {
              width: 100% !important;
              height: auto !important;
              max-height: 58px;
              margin: 10px !important;
            }
            .card32-scope .card32-timer-row {
              display: flex;
              align-items: center;
              justify-content: space-between;
              padding: 3px 12px;
            }
            .mobile-height{
              height: auto !important;
              min-height: 300px;
            }
          }
        `}
      </style>
    </div>
  );
}
